import React from 'react';
import {useLoaderData} from '@remix-run/react';

//components
import {Link} from 'components/Link';

//data
import {loader} from '~/routes/($lang)/blogs/$categoryHandle/$slug/index';

export default function BlogDetailsBreadcrumb() {
  const {currentBlog, nextBlog, previousBlog, translation, blogSettings} =
    useLoaderData<typeof loader>();
  return (
    <nav className="mt-6 mb-[34px] flex flex-wrap items-center">
      <Link
        to="/"
        className="transition-colors duration-200 ease-out hover:text-hk-orange"
      >
        {translation?.home ?? 'Home'}
      </Link>
      <span className="mx-2 inline-block">/</span>
      <Link
        to="/blogs"
        className="transition-colors duration-200 ease-out hover:text-hk-orange"
      >
        {blogSettings?.blogs_label}
      </Link>
      <span className="mx-2 inline-block">/</span>
      <Link
        to={`/blogs/${currentBlog.blog_category.slug.current}`}
        className="transition-colors duration-200 ease-out hover:text-hk-orange"
      >
        {currentBlog.blog_category.category_title}
      </Link>
      <span className="mx-2 inline-block">/</span>
      <span className="">{currentBlog.blog_title}</span>
    </nav>
  );
}
